import { useState } from 'react'
import Box from '@mui/system/Box'
import NewReportModal from '../components/NewReportModal'

const ActionNewReportButton = ({ children, selectedCategory, clickable, skipToCreate }) => {
  // modal states and function
  const [isModalOpen, setModalOpen] = useState(false)
  const handleOpen = () => {
    if (clickable) {
      setModalOpen(true)
    }
  }
  const handleClose = () => {
    setModalOpen(false)
    // setNewClaimReport(false)
    setNewClaimReport(skipToCreate ?? false)
    setSelectedClaimReport(false)
  }

  // children states and function
  // const [isNewClaimReport, setNewClaimReport] = useState(false)
  const [selectedClaimReport, setSelectedClaimReport] = useState(false)
  const [isNewClaimReport, setNewClaimReport] = useState(skipToCreate ?? false)

  return (
    <Box sx={{ width: 1 }}>
      <Box onClick={handleOpen} sx={{ cursor: clickable && 'pointer' }}>
        {children}
      </Box>
      <NewReportModal
        isModalOpen={isModalOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
        selectedClaimReport={selectedClaimReport}
        setSelectedClaimReport={setSelectedClaimReport}
        isNewClaimReport={isNewClaimReport}
        setNewClaimReport={setNewClaimReport}
        // state if click from allocation panel
        selectedCategory={selectedCategory}
      />
    </Box>
  )
}

export default ActionNewReportButton
